<template>
  <div class="child-modal">
    <div class="content-box" ref="content" v-if="SpotModalData.length > 0">
      <div @click="closeModal" class="close"></div>
      <div @click="curMode == 0 ? curMode = 1 : curMode = 0" class="switch-mode">{{curMode == 0 ? '地图模式' : '列表模式'}}</div>
      <div class="title">{{ title }}</div>

      <div class="search">
        <input placeholder="搜索景区" type="text" />
        <div class="search-btn"></div>
      </div>
      <div class="content">
        <ol class="tab">
          <li :class="{ current: curTab == index }" :key="index" @click="curTab = index" v-for="(item, index) in tabList">{{ item }}</li>
        </ol>
        <div class="spot-list" v-show="curMode == 0">
          <div class="wrapper">
            <BScroll :scrollbar="true">
              <ul class="spot-box">
                <li :key="index" @click="goSpotRealtime" v-for="(item, index) in SpotModalData">
                  <div class="up">
                    <img src="http://cdn.gaifan.cn/165/158/1564051464899.jpg" />
                  </div>
                  <div class="down">
                    <div class="info">
                      <div class="spot-name">{{ item.spot_name }}</div>
                      <div class="spot-count">{{ item.spot_count }}</div>
                    </div>
                    <div class="label">
                      <span>{{ item.spot_label[0] }}</span>
                      <span>{{ item.spot_label[1] }}</span>
                    </div>
                    <div class="praise">
                      好评率
                      <span>{{ item.spot_praise }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </BScroll>
          </div>
          <div class="page">
            <PageHelper :page-number="pageNumber" :totalCount="SpotModalData.length" @jumpPage="jumpPage"></PageHelper>
          </div>
        </div>
        <div class="spot-map" v-show="curMode == 1">
          <div id="spotMap"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHelper from '@/components/Common/PageHelper.vue'
import BScroll from '@/components/Common/BScroll.vue'

export default {
  name: 'SpotModal',
  components: {
    PageHelper,
    BScroll
  },
  props: {
    title: String
  },
  data() {
    return {
      curMode: 0,
      colorList: ['#ba2828', '#00cdff', '#a1e058', '#1e89ff', '#ffe05f'],
      map: null,
      pageNumber: 1,
      curTab: 0,
      SpotModalData: [],
      tabList: [
        '客流热度',
        '5A',
        '4A',
        '3A及以下',
        '山水',
        '博物馆',
        '海岛',
        '主题公园'
      ]
    }
  },
  mounted() {
    // 请求景区列表
    fetch('/data/SpotModal.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.SpotModalData = json.data
        setTimeout(() => {
          this.map = new AMap.Map('spotMap', {
            mapStyle: 'amap://styles/5411bd4e683c3b6f54012fe05ad53f5a'
          })
          // 遍历增加标记
          for (let i = 0; i < this.SpotModalData.length; i++) {
            // 创建纯文本标记
            var text = new AMap.Text({
              text: this.SpotModalData[i].spot_name,
              anchor: 'center',
              cursor: 'pointer',
              style: {
                borderRadius: '5px',
                backgroundColor: this.colorList[
                  Math.round(Math.random() * (this.colorList.length - 1))
                ],
                opacity: '0.8',
                width: this.SpotModalData[i].spot_name.length * 16 + 'px',
                height: '20px',
                lineHeight: '16px',
                textAlign: 'center',
                color: '#111',
                border: 'none'
              },
              position: this.SpotModalData[i].spot_coord
            })
            // 推入地图
            text.setMap(this.map)
            text.on('click', e => {
              this.closeModal()
              this.$router.push({ path: '/spotrealtime' })
            })

            // 创建一个 icon
            var endIcon = new AMap.Icon({
              size: new AMap.Size(50, 50),
              image: this.SpotModalData[i].spot_icon,
              imageSize: new AMap.Size(50, 50)
            })

            // 将 icon 传入 marker
            var endMarker = new AMap.Marker({
              position: new AMap.LngLat(
                this.SpotModalData[i].spot_coord[0],
                this.SpotModalData[i].spot_coord[1]
              ),
              icon: endIcon,
              offset: new AMap.Pixel(-25, -60)
            })

            // 将 markers 添加到地图
            this.map.add([endMarker])
          }
          this.map.setFitView()
        }, 210)
      })
    setTimeout(() => {
      this.$refs.content.style.transform = 'scale(1)'
    }, 200)
  },
  methods: {
    closeModal() {
      this.$refs.content.style.transform = 'scale(0)'
      setTimeout(() => {
        this.$store.commit('setSpotModalShow')
      }, 300)
    },
    jumpPage(pageinfo) {
      console.log(pageinfo)
    },
    goSpotRealtime() {
      this.closeModal()
      this.$router.push({ path: '/spotrealtime' })
    }
  },
  watch: {
    curMode(val) {
      setTimeout(() => {
        this.map.setFitView()
      }, 50)
    }
  }
}
</script>

<style scoped lang="less">
h2 {
  font-size: 10rem;
  color: #fff;
}
.child-modal {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  .content-box {
    padding: 0.3rem;
    box-sizing: border-box;
    width: 14rem;
    height: 9rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -7rem;
    margin-top: -4.5rem;
    transform: scale(0);
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.5) url(../assets/spot_bg.jpg);
    background-size: 100% 100%;
    box-shadow: 0 0 1.2rem rgba(0, 0, 0, 0.8);
    .title {
      height: 0.5rem;
      font-size: 0.24rem;
      color: #00cdf9;
      font-weight: bold;
    }
    .switch-mode {
      width: 1rem;
      height: 0.32rem;
      line-height: 0.31rem;
      border: 1px solid #07779e;
      background: #0e264b;
      position: absolute;
      left: 4.7rem;
      top: 0.3rem;
      cursor: pointer;
    }
    .search {
      width: 2.3rem;
      height: 0.26rem;
      position: absolute;
      top: 0.34rem;
      right: 2.4rem;
      input {
        width: 2.02rem;
        height: 0.26rem;
        background: #0e264b;
        border: 0.02rem solid #07779e;
        outline: none;
        float: left;
        padding-left: 0.1rem;
        color: #fff;
      }
      .search-btn {
        width: 0.26rem;
        height: 0.26rem;
        float: right;
        background: url(../assets/spot_search_btn.jpg);
        background-size: 100% 100%;
        cursor: pointer;
      }
      input::-webkit-input-placeholder {
        color: #ccc;
      }
    }
    .close {
      width: 0.22rem;
      height: 0.23rem;
      background: url(../assets/close.png);
      background-size: 100% 100%;
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;
      z-index: 99;
      cursor: pointer;
    }
    .content {
      overflow: hidden;
      width: 100%;
      height: 92.5%;
      box-sizing: border-box;
      .tab {
        width: 9.4rem;
        height: 0.24rem;
        margin: 0 auto 0.26rem;
        li {
          width: 12.5%;
          height: 100%;
          float: left;
          color: #fff;
          background: url(../assets/spot_tab_bg.png);
          background-size: 100% 100%;
          cursor: pointer;
        }
        .current {
          background: url(../assets/spot_tab_bg_.png);
          background-size: 100% 100%;
        }
      }
      .spot-map {
        width: 10.4rem;
        height: 7rem;
        margin: 0 auto;
        #spotMap {
          width: 100%;
          height: 100%;
        }
      }
      .spot-list {
        width: 10.4rem;
        height: 7rem;
        margin: 0 auto;
      }
      .wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .spot-box {
        width: 10.4rem;
        overflow: hidden;
        li {
          width: 2.32rem;
          height: 3.26rem;
          float: left;
          background: rgba(57, 132, 188, 0.4);
          margin: 0 0.14rem 0.24rem;
          border-radius: 0.12rem;
          padding: 0.15rem;
          box-sizing: border-box;
          cursor: pointer;
          .up {
            width: 2.02rem;
            height: 2.02rem;
            position: relative;
            overflow: hidden;
            img {
              height: 100%;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .down {
            margin-top: 0.14rem;
            font-size: 0.14rem;
            color: #fff;
            > div {
              height: 0.3rem;
            }
            .info {
              color: #00cdff;
              font-size: 0.2rem;
              font-weight: bold;
              .spot-name {
                float: left;
              }
              .spot-count {
                float: right;
              }
            }
            .label {
              > span {
                border: 1px solid #fff;
                border-radius: 1rem;
                padding: 0 0.1rem;
                float: left;
                margin-right: 0.04rem;
              }
            }
            .praise {
              text-align: left;
              > span {
                color: #ffdc48;
              }
            }
          }
        }
      }
      .page {
        width: 9rem;
        margin: 0 auto;
        background: #1b3e65;
      }
    }
  }
}
</style>
